import { Component, Injectable, Input, OnInit } from '@angular/core';
import { AuthGuard } from '../../auth.guard';
import { Articulo } from '../../models/articulo.model';
import { CompraService } from '../../services/compra.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { ArticuloService } from '../../services/articulo.service';
import { PedidoService } from '../../services/pedido.service';

@Component({
  standalone: true,
  selector: 'app-articulo-prop-widget',
  templateUrl: './articulo-prop-widget.component.html',
  styleUrls: ['./articulo-prop-widget.component.scss'],
  imports: [CommonModule]
})

export class ArticuloPropWidgetComponent implements OnInit {
  @Input() articulo!: Articulo;
  @Input() gridListViene: boolean = false;
  filtrosShop = environment.FILTROS_SHOP;
  COMPRAR_SIN_STOCK = environment.COMPRAR_SIN_STOCK;
  ART_PESO_VER_PESO = environment.ART_PESO_VER_PESO;
  dia: Date;
  diaYYYY: string;
  artYYYY: string = '';
  gridList: boolean = false;

  constructor(
    public authService: AuthService,
    private compraService: CompraService,
    private articuloService: ArticuloService,
    public pedidoService: PedidoService,
  ) {
    this.dia = new Date();
    this.diaYYYY = this.dia.getFullYear().toString();
  }

  ngOnInit(): void {
    this.gridList = this.gridListViene ? false : this.articuloService.gridList;

    if (this.articulo.ult_fecha !== null) {
      const artDate = new Date(this.articulo.ult_fecha);
      this.artYYYY = artDate.getFullYear().toString();
    }
  }

  lista(articulo: Articulo) {
    this.compraService.lista(articulo);
    if (this.pedidoService.lista.length <= 0) {
      articulo.lista_pedcl_id == null;
    }
  }
}
